import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { obterPerfisIdPositiva, obterPerfisPorCpf } from '../../api/pessoaAPI';
import { verificarPossiblidadeRemocaoFamiliaCadUnico } from '../../api/familiaAPI';
import { obterSituacaoCadastroFamilia, verificarPossiblidadeRemocaoPreFamiliaCadUnico } from '../../api/preCadastroAPI';
import { RootState } from '../../app/store';
import { PessoaModel } from '../../model/Pessoa';


export interface PerfilState {
  buscandoPerfis: boolean;
  perfis: any[];
  tipoPerfil: number | null;
  numeroFamiliar: any;
  perfilCompleto: any;
  situacaoCadastroFamilia: any;
  permiteRemoverFamiliaCadUnico: boolean | null;
  atualizacaoSincronizada: boolean | null;
  permiteRemoverPreFamiliaCadUnico: boolean | null;
  selecionouSolicitacaoCadastramento: boolean;
}

const initialState: PerfilState = {
  buscandoPerfis: false,
  perfis: [],
  tipoPerfil: null,
  numeroFamiliar: null,
  perfilCompleto: null,
  situacaoCadastroFamilia: null,
  permiteRemoverFamiliaCadUnico: null,
  atualizacaoSincronizada: null,
  permiteRemoverPreFamiliaCadUnico: null,
  selecionouSolicitacaoCadastramento: false,
};

export const getPermiteRemoverFamiliaCadUnico = createAsyncThunk(
  'perfil/getPermiteRemoverFamiliaCadUnico',
  async (data: any) => {
    return verificarPossiblidadeRemocaoFamiliaCadUnico(data.cpf, data.numeroFamiliar);
  }
);

export const getPermiteRemoverPreFamiliaCadUnico = createAsyncThunk(
  'perfil/getPermiteRemoverPreFamiliaCadUnico',
  async (data: any) => {
    return verificarPossiblidadeRemocaoPreFamiliaCadUnico(data.cpf, data.idPreFamilia);
  }
);

export const getPerfis = createAsyncThunk('perfil/getPerfis', async (cpf: string) => {
  return obterPerfisPorCpf(cpf);
});

export const getPerfisSolicitacaoCadastramentoRL = createAsyncThunk('perfil/getPerfisSolicitacaoCadastramentoRL', async (cpf: string) => {
  return obterPerfisPorCpf(cpf);
});

export const getPerfisIdPositiva = createAsyncThunk(
  'perfil/getPerfisIdPositiva',
  async (pessoa: PessoaModel) => {
    return obterPerfisIdPositiva(pessoa);
  }
);

export const getSituacaoCadastroFamilia = createAsyncThunk(
  'perfil/getSituacaoCadastroFamilia',
  async (data: any, { dispatch }) => {
    // try {
      if (data && data.cpf) {
        const response = await obterSituacaoCadastroFamilia(data.cpf);
        return response;
      }
      return null;
    // } catch (e:any) {
    //   if (e.name === "NetworkError") {
    //     try {
    //       const response = await obterSituacaoCadastroFamilia(data.cpf);
    //       return response;
    //     } catch (e) {
    //       dispatch(authLogout({ history: data.history }));
    //       throw e;
    //     }
    //   } else {
    //     throw e;
    //   }
    }
  // }
);

export const perfilSlice = createSlice({
  name: 'perfil',
  initialState,
  reducers: {
    setBuscandoPerfis: (state, action) => {
      state.buscandoPerfis = action.payload;
    },
    selecionarPerfil: (state, action) => {
      state.perfilCompleto = action.payload;
      // Só resetar se for um perfil diferente ou se não tiver valor
      if (!state.permiteRemoverFamiliaCadUnico ||
          (state.numeroFamiliar && state.numeroFamiliar !== action.payload?.numeroFamiliar)) {
        state.permiteRemoverFamiliaCadUnico = initialState.permiteRemoverFamiliaCadUnico;
        state.atualizacaoSincronizada = initialState.atualizacaoSincronizada;
      }
    },
    selecionarTipoPerfil: (state, action) => {
      state.tipoPerfil = action.payload;
    },
    selecionarNumeroFamiliar: (state, action) => {
      state.numeroFamiliar = action.payload;
    },
    setSelecionouSolicitacaoCadastramento: (state, action) => {
      state.selecionouSolicitacaoCadastramento = action.payload;
    },
    limparPerfil: (state) => {
      state.tipoPerfil = initialState.tipoPerfil;
      state.numeroFamiliar = initialState.numeroFamiliar;
      state.perfilCompleto = initialState.perfilCompleto;
      state.buscandoPerfis = initialState.buscandoPerfis;
      state.perfis = initialState.perfis;
      state.situacaoCadastroFamilia = initialState.situacaoCadastroFamilia;
      state.permiteRemoverFamiliaCadUnico = initialState.permiteRemoverFamiliaCadUnico;
      state.atualizacaoSincronizada = initialState.atualizacaoSincronizada;
      state.permiteRemoverPreFamiliaCadUnico = initialState.permiteRemoverPreFamiliaCadUnico;

      state.selecionouSolicitacaoCadastramento = initialState.selecionouSolicitacaoCadastramento;
      state.selecionouSolicitacaoCadastramento = initialState.selecionouSolicitacaoCadastramento;

      state = initialState;
    },
    perfilUpdated: () => {}
  },
  extraReducers: (builder) => {
    builder.addCase(getPerfisSolicitacaoCadastramentoRL.fulfilled, (state, action) => {
      if (action.payload && action.payload.length === 0) {
        state.selecionouSolicitacaoCadastramento = true;
      }
    })
    builder.addCase(getPerfis.fulfilled, (state, action) => {
      state.buscandoPerfis = false;
      state.perfis = action.payload;

      if (state.perfis && state.perfis.length === 1) {
        state.tipoPerfil = state.perfis[0].tipoPerfil.codigo;
        state.numeroFamiliar =state.perfis[0].numeroFamiliar;
        state.perfilCompleto = state.perfis[0];
        // Só resetar se for um perfil diferente ou se não tiver valor
        if (!state.permiteRemoverFamiliaCadUnico ||
            (state.numeroFamiliar && state.numeroFamiliar !== state.perfis[0].numeroFamiliar)) {
          state.permiteRemoverFamiliaCadUnico = initialState.permiteRemoverFamiliaCadUnico;
          state.atualizacaoSincronizada = initialState.atualizacaoSincronizada;
        }
      }

       if (state.perfis && state.perfis.length === 0) {
        state.selecionouSolicitacaoCadastramento = true;
        }
    })
    builder.addCase(getPerfisIdPositiva.fulfilled, (state, action) => {
      state.buscandoPerfis = false;
      state.perfis = action.payload;
    })
    builder.addCase(getSituacaoCadastroFamilia.fulfilled, (state, action) => {
      state.situacaoCadastroFamilia = action.payload;
    });
    builder.addCase(getSituacaoCadastroFamilia.rejected, (state, action) => {
      localStorage.setItem(
        'cadunico/situacaoCadastroFamilia/responseError',
        JSON.stringify({
          name: action.error.name,
          message: action.error.message
        })
      );
    });
    builder.addCase(getPermiteRemoverFamiliaCadUnico.fulfilled, (state, action) => {
      state.permiteRemoverFamiliaCadUnico = action.payload?.permiteExclusaoFamilia;
      state.atualizacaoSincronizada = action.payload?.atualizacaoSincronizada;
    });
    builder.addCase(getPermiteRemoverFamiliaCadUnico.rejected, (state, action) => {
      console.log('Exceção ao chamar getPermiteRemoverFamiliaCadUnico')

      state.permiteRemoverFamiliaCadUnico = false;

    });
    builder.addCase(getPermiteRemoverPreFamiliaCadUnico.fulfilled, (state, action) => {
      state.permiteRemoverPreFamiliaCadUnico = action.payload;
    });
  },
});

export const {
  setBuscandoPerfis,
  selecionarPerfil,
  selecionarTipoPerfil,
  selecionarNumeroFamiliar,
  setSelecionouSolicitacaoCadastramento,
  limparPerfil,
  perfilUpdated
} = perfilSlice.actions;

export const selectBuscandoPerfis = (state: RootState) => state.perfil.buscandoPerfis;
export const selectPerfis = (state: RootState) => state.perfil.perfis;
export const selectTipoPerfil = (state: RootState) => state.perfil.tipoPerfil;
export const selectNumeroFamiliar = (state: RootState) => state.perfil.numeroFamiliar;
export const selectPerfilCompleto = (state: RootState) => state.perfil.perfilCompleto;
export const selectPermiteRemoverFamiliaCadUnico = (state: RootState) => state.perfil.permiteRemoverFamiliaCadUnico;
export const selectAtualizacaoSincronizada = (state: RootState) => state.perfil.atualizacaoSincronizada;
export const selectPermiteRemoverPreFamiliaCadUnico = (state: RootState) => state.perfil.permiteRemoverPreFamiliaCadUnico;
export const selectSelecionouSolicitacaoCadastramento = (state: RootState) => state.perfil.selecionouSolicitacaoCadastramento;

export const selectSituacaoCadastroFamilia = (state: RootState) =>
  state.perfil.situacaoCadastroFamilia;

export default perfilSlice.reducer;
